import {
  ORDER_STATUS_LABELS,
  ORDER_STATUS_COLORS,
  CONSULTATION_STATUS_LABELS,
  CONSULTATION_STATUS_COLORS,
  type OrderStatus,
  type ConsultationStatus,
} from '@bharat-consultancy/shared';

export function StatusBadge({ status }: { status: OrderStatus }) {
  const colors = ORDER_STATUS_COLORS[status];
  return (
    <span className={`inline-flex items-center rounded-full px-3 py-1 text-xs font-medium ${colors.bg} ${colors.text}`}>
      {ORDER_STATUS_LABELS[status]}
    </span>
  );
}

export function ConsultationStatusBadge({ status }: { status: ConsultationStatus }) {
  const colors = CONSULTATION_STATUS_COLORS[status];
  return (
    <span className={`inline-flex items-center rounded-full px-3 py-1 text-xs font-medium ${colors.bg} ${colors.text}`}>
      {CONSULTATION_STATUS_LABELS[status]}
    </span>
  );
}
